import React, { Component } from "react";
import { Link } from "react-router-dom";

import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";

export default class AddGroup extends Component {
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/admin/groups">Groups</Link> / <b> Add Group</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="eg. Accounting"
                  id="inputDefault"
                />
              </div>
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Discription
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Discription"
                  id="inputDefault"
                />
              </div>
            </div>
          </div>
            
          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary"> Save</div> or{" "}
            <Link to="/admin/groups" className="btn-link">Cancel</Link>
          </div>
        </div>
      </div>
    );
  }
}
